import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "@/shared/services/apiClient";
import { API_ROUTES } from "@/shared/services/apiRoutes";
import { useToast } from "@/shared/hooks/use-toast";
import { Loader2 } from "lucide-react";

export default function GoogleCalendarCallbackPage() {
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const error = params.get("error");

    if (error || !code) {
      toast({
        title: "Google Calendar connection cancelled",
        description: error ? `Error: ${error}` : "No authorization code received.",
        variant: "destructive",
      });
      navigate("/profile?tab=integrations", { replace: true });
      return;
    }

    const redirectUri = `${window.location.origin}/auth/google-calendar/callback`;

    apiClient
      .post<{ ok: boolean; email: string }>(API_ROUTES.GOOGLE_CALENDAR_CONNECT, {
        code,
        redirectUri,
      })
      .then((data) => {
        toast({
          title: "Google Calendar connected!",
          description: `Syncing to ${data.email}`,
        });
        navigate("/profile?tab=integrations", { replace: true });
      })
      .catch((err: any) => {
        toast({
          title: "Connection failed",
          description: err.message || "Failed to connect Google Calendar.",
          variant: "destructive",
        });
        navigate("/profile?tab=integrations", { replace: true });
      });
  }, [navigate, toast]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-muted-foreground">Connecting Google Calendar...</p>
      </div>
    </div>
  );
}
